import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
interface FinalCtaProps {
  onCta: () => void;
}
export function FinalCta({
  onCta
}: FinalCtaProps) {
  return <section className="bg-gradient-to-b from-[#4a1d6a] to-[#35114f] px-4 py-16 pb-28 text-center text-white" data-id="element-92" data-mp="19f7cz0l765b9">
      <div className="mx-auto max-w-md" data-id="element-93" data-mp="15ckjywcsiech">
        <h2 className="font-display text-3xl font-bold leading-tight" data-id="element-94" data-mp="15fq7461uz65k">
          Cada sesión puede convertirse en un punto de inflexión.
        </h2>
        <p className="mt-3 text-lg font-semibold text-pink" data-id="element-95" data-mp="1ed0mo3lplhga">
          Todo comienza con la pregunta correcta.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-white/80" data-id="element-96" data-mp="1t253bgcuvdma">
          Deja de improvisar. Empieza a conducir cada sesión con seguridad, claridad y propósito.
        </p>

        <div className="mt-7 rounded-2xl bg-white/95 p-4" data-id="element-97" data-mp="224eco2we10y3">
          <CountdownTimer data-id="element-98" data-mp="1x4tf9wwv90nh" />
        </div>

        <div className="mt-6" data-id="element-99" data-mp="1x5umtreob50g">
          <CtaButton onClick={onCta} data-id="element-100" data-mp="1x2ozohplud7d">Quiero el Oráculo de las Preguntas</CtaButton>
        </div>
        <p className="mt-4 text-xs text-white/60" data-id="element-101" data-mp="n7p8rlpkhpnh">
          Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días
        </p>

        <p className="mt-10 text-xs text-white/40" data-id="element-102" data-mp="x3ip7g6eq3aj">
          © {new Date().getFullYear()} Dra. Karito — El Oráculo de las Preguntas. Todos los derechos
          reservados.
        </p>
      </div>
    </section>;
}